import { render, staticRenderFns } from "./JobBoard.vue?vue&type=template&id=e6b60c24&scoped=true"
import script from "./JobBoard.vue?vue&type=script&lang=js"
export * from "./JobBoard.vue?vue&type=script&lang=js"
import style0 from "./JobBoard.vue?vue&type=style&index=0&id=e6b60c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b60c24",
  null
  
)

export default component.exports